import React from "react";

const NotesIcon = ({ show }) => {
  return (
    <>
      <div onClick={show} className="icon notes">
        <span>Notes</span>
      </div>
    </>
  );
};

export default NotesIcon;
